export default __webpack_public_path__ + "static/media/fize.f408999f.svg";